import React from 'react'
import { SkeletonParagraphProps, SkeletonComponsition } from './Skeleton.types'
import { StyledBox } from './styled'
import Avatar from './Avatar'
import Paragraph from './Paragraph'
import Image from './Image'

const index: React.FC<SkeletonParagraphProps> & SkeletonComponsition = ({
  width = '100%',
  height = '24px',
  color = 'black25',
  ...props
}) => {
  return (
    <StyledBox
      borderRadius='8px'
      backgroundColor={color}
      height={height}
      width={width}
      {...props}
    />
  )
}

index.Avatar = Avatar
index.Paragraph = Paragraph
index.Image = Image

export default index
